import React from 'react';

const DividerItem = () => {
  return (
    <div className="flex h-3.5 shrink-0 items-center px-0">
      <div className="bg-background h-px w-full"></div>
    </div>
  );
};

export default DividerItem;
